import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票信息")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import { ref } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseDatePicker,
  BaseSelect
} from 'xrk-components';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import { selectParkList } from '@V/invoice/src/data-source/apis';
import { INVOICE_TYPE } from '@V/invoice/src/constants';
/** 支付通道（全局常量 @constants/bank） */
import { PAY_PASSAGEWAY_MAPPING } from '@constants/bank';
/** 付款方式（全局常量 @constants/order） */
import { PAY_TYPE } from '@constants/order';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

type FormData = MakeOutAnInvoiceParams &
  NotInvoicedListParams & {
    individualId?: number | null;
    individualName?: string;
  };


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-apply-individual-dialog-content',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {



const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const formData = _useModel<FormData>(__props, "modelValue");
const formRef = ref(null);

const formRules = {
  theSellerId: [{ required: true, message: '请选择', trigger: 'change' }],
  invoiceType: [{ required: true, message: '请选择', trigger: 'change' }],
  payPassagewayCode: [{ required: false, message: '请选择', trigger: 'change' }]
};

/** 支付通道选项（来源 @constants/bank PAY_PASSAGEWAY_MAPPING） */
const PAY_CHANNEL_OPTIONS = Object.values(PAY_PASSAGEWAY_MAPPING);

/** 付款方式选项（来源 @constants/order PAY_TYPE） */
const PAY_TYPE_OPTIONS = Object.values(PAY_TYPE);

const gthRemote = (keyWord: string) => {
  return selectParkList({
    keyWord,
    pageNum: 1,
    pageSize: 200,
    loginUserId: userInfo.value.loginUserId,
    functionCode: userInfo.value.functionCode
  });
};

const onGthChange = (val, [option]) => {
  formData.value.itemId = null;
  formData.value.entpCertNo = option.entpCertNo;
  formData.value.individualId = option.individualId;
  formData.value.individualName = option.individualName;
};
const onInvoiceTypeChange = () => {
  formData.value.itemId = null;
};
__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: formData.value,
    rules: formRules,
    disabled: _ctx.disabled
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "个体户名称",
          prop: "theSellerId"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              placeholder: "请选择",
              "label-key": "individualName",
              "value-key": "individualId",
              init: true,
              remoteMethod: gthRemote,
              modelValue: formData.value.theSellerId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.theSellerId) = $event)),
              onChange: onGthChange
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "发票类型",
          prop: "invoiceType"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              modelValue: formData.value.invoiceType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.invoiceType) = $event)),
              options: _unref(INVOICE_TYPE),
              onChange: onInvoiceTypeChange
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "支付通道",
          prop: "payPassagewayCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请选择",
              modelValue: formData.value.payPassagewayCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.payPassagewayCode) = $event)),
              options: _unref(PAY_CHANNEL_OPTIONS)
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "选择日期",
          prop: "receiveAt"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseDatePicker), {
              class: "form-dialog__w280",
              style: {"width":"280px"},
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              type: "daterange",
              modelValue: formData.value.receiveAt,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.receiveAt) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "付款方式",
          prop: "payType"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请选择",
              modelValue: formData.value.payType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.payType) = $event)),
              options: _unref(PAY_TYPE_OPTIONS)
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "disabled"]))
}
}

})